module.exports = __webpack_public_path__ + "static/img/5.534de4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/eng/5.png
// module id = l+sZ
// module chunks = 0